var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_19",
    "data-name": "Gruppe 19",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.769,
    height: 69.769,
    viewBox: "0 0 69.769 69.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M0,0H69.769V69.769H0Z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 9.302,
    cy: 9.302,
    r: 9.302,
    transform: "translate(25.582 25.582)",
    fill: "#bcb243"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M22.349,2l-5.32,5.814H7.814A5.831,5.831,0,0,0,2,13.628V48.512a5.831,5.831,0,0,0,5.814,5.814H54.326a5.831,5.831,0,0,0,5.814-5.814V13.628a5.831,5.831,0,0,0-5.814-5.814H45.111L39.791,2ZM31.07,45.605A14.535,14.535,0,1,1,45.605,31.07,14.54,14.54,0,0,1,31.07,45.605Z",
    transform: "translate(3.814 3.814)",
    fill: "#bcb243"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhoto);
export default __webpack_public_path__ + "static/media/icon-photo.2ae1fb574361668d4420b9516d3a3435.svg";
export { ForwardRef as ReactComponent };